<template>
  <div class="blockedCard">
    <!-- <p style="margin: 0; font-weight: 600; color: rgb(127 126 126)">
      {{ contact.dateFormatted }}
    </p> -->
    <div class="blockedCard-body">
      <div class="cardTitle">
        <p
          style="margin: 0; font-weight: 600; color: #333333"
          class="blockedCard"
        >
          <span style="font-weight: 500; color: #6a6a6a">{{
            contact.dateFormatted
          }}</span>
          -
          {{ contact.firstname + " " + contact.lastname }}
        </p>
        <p style="margin: 0" @click="copyField(contact.email)">
          <span class="field">{{ contact.email }}</span>
        </p>
        <p
          v-if="contact.provider"
          style="margin: 0 0 0 5px"
          @click="copyField(contact.provider.providerName)"
        >
          -
          <span class="field">{{ contact?.provider?.providerName }}</span>
        </p>
      </div>
      <div style="display: flex; flex-direction: column">
        <button
          :id="`unblockBtn-${index}`"
          :disabled="isLoading"
          class="btn btn-primary"
          @click="unblock"
        >
          Desbloquear
        </button>
        <button
          :id="`deleteBlockedBtn-${index}`"
          :disabled="isLoading"
          class="btn btn-danger"
          style="margin-top: 8px"
          @click="openDeleteModal"
        >
          Eliminar
        </button>
      </div>
    </div>

    <div v-if="showDeleteModal" class="modal-backdrop-saludsa" @click="closeDeleteModal" />
    <div
      v-if="showDeleteModal"
      class="modal-saludsa"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="`deleteBlockedTitle-${index}`"
      @keydown.esc.prevent="closeDeleteModal"
    >
      <div class="modal-saludsa-content" @click.stop>
        <div class="modal-saludsa-header">
          <h5 class="modal-saludsa-title" :id="`deleteBlockedTitle-${index}`">
            Confirmar eliminación
          </h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Cerrar"
            :disabled="isLoading"
            @click="closeDeleteModal"
          />
        </div>

        <div class="modal-saludsa-body">
          <p style="margin: 0">
            ¿Seguro que deseas eliminar a <b>{{ deleteLabel }}</b> de la lista de bloqueados?
            Esta acción no se puede deshacer.
          </p>
        </div>

        <div class="modal-saludsa-footer">
          <button
            type="button"
            class="btn btn-secondary"
            :disabled="isLoading"
            @click="closeDeleteModal"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-danger"
            :disabled="isLoading"
            @click="deleteBlocked"
          >
            <span v-if="!isLoading">Eliminar</span>
            <span v-else><i class="fas fa-circle-notch fa-spin"></i> Eliminando...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlockedUserComponent",
  props: ["tokenAuth", "contact", "index"],
  data() {
    return {
      isLoading: false,
      showDeleteModal: false,
    };
  },
  computed: {
    deleteLabel() {
      const fullName = `${this.contact?.firstname || ""} ${
        this.contact?.lastname || ""
      }`.trim();
      return fullName || this.contact?.email || "este usuario";
    },
  },
  watch: {},
  mounted() {
    this.$eventBus.emit("refreshMonthLeads");
  },
  methods: {
    copyField(fieldValue) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(fieldValue)
          .then(() => {
            this.$toast.success(`${fieldValue} copiado exitosamente.`, {
              position: "top-right",
              max: 10,
            });
          })
          .catch((err) => {
            console.error("No se pudo copiar el campo: ", err);
            this.$toast.error("Falla al copiar el campo.", {
              position: "top-right",
              max: 10,
            });
          });
      } else {
        console.error("Clipboard API not available.");
        this.$toast.error("Clipboard functionality not available.", {
          position: "top-right",
          max: 10,
        });
      }
    },
    unblock() {
      this.isLoading = true;
      document.getElementById(`unblockBtn-${this.index}`).innerHTML =
        '<i class="fas fa-circle-notch fa-spin"></i> Desbloqueando...';

      // Determinar qué endpoint usar basándose en userId o promoCode
      const endpoint = this.contact.userId
        ? "/hubspot/updateBlockedContactApp"
        : "/hubspot/updateBlockedContact";

      this.$https
        .post(endpoint, {
          tokenAuth: this.tokenAuth,
          ...this.contact,
        })
        .then((response) => {
          if (response.data.code === 204) {
            this.$toast.error(response.data.message, {
              position: "top-right",
              max: 10,
            });
          } else if (response.status === 201) {
            this.$toast.success(response.data.message, {
              position: "top-right",
              max: 10,
            });
            this.refreshBlockedContacts();
          }
          document.getElementById(`unblockBtn-${this.index}`).innerHTML =
            "Desbloquear";
          this.isLoading = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.error, {
            position: "top-right",
            max: 10,
          });
          document.getElementById(`unblockBtn-${this.index}`).innerHTML =
            "Desbloquear";
          this.isLoading = false;
        });
    },
    openDeleteModal() {
      if (this.isLoading) return;
      this.showDeleteModal = true;
    },
    closeDeleteModal() {
      if (this.isLoading) return;
      this.showDeleteModal = false;
    },
    deleteBlocked() {
      this.isLoading = true;

      this.$https
        .post("/hubspot/deleteBlockedContact", {
          tokenAuth: this.tokenAuth,
          email: this.contact.email,
        })
        .then((response) => {
          if (response?.data?.code === 204) {
            this.$toast.error(response.data.message, {
              position: "top-right",
              max: 10,
            });
          } else {
            this.$toast.success(response.data.message, {
              position: "top-right",
              max: 10,
            });
            this.refreshBlockedContacts();
            this.showDeleteModal = false;
          }
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            "Error eliminando usuario bloqueado.";
          this.$toast.error(msg, {
            position: "top-right",
            max: 10,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    refreshBlockedContacts() {
      this.$eventBus.emit("refreshBlockedContacts");
    },
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

.blockedCard {
  //   border: 1px solid #ccc;
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.blockedCard.expanded {
  height: auto;
}

.blockedCard-header {
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.blockedCard-body {
  display: flex;
  justify-content: space-between;
}

.form-control {
  background-color: #f7f7f7; /* Light grey background on hover */
}

.form-control:hover {
  background-color: #f0f0f0; /* Light grey background on hover */
  color: #888; /* Lighter text color on hover */
}

.form-control:active {
  background-color: #cccccc; /* Light grey background on hover */
  color: #6e6e6e; /* Lighter text color on hover */
}

.form-control-label {
  font-size: 14px !important;
}
.cardTitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.company-data-2-fields {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  @media (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.modal-backdrop-saludsa {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}

.modal-saludsa {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1060;
}

.modal-saludsa-content {
  width: min(560px, 100%);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-saludsa-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
}

.modal-saludsa-title {
  margin: 0;
  font-weight: 700;
  color: #333333;
}

.modal-saludsa-body {
  padding: 16px;
  color: #333333;
}

.modal-saludsa-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e9ecef;
}
</style>
